export default `fragment articleSellerFields on ArticleSellerType {    
      id    
      blackSeller    
      whiteSeller  
  }  
  fragment articleFields on ArticleType {    
      livesearchId    
      id     
      user_product_id
      title
      price    
      currency    
      catalogListing    
      catalogProductId    
      officialStoreId    
      availableQuantity    
      categoryId    
      condition    
      keyAttr    
      bundle{    
          type    components{    
              type    user_product_id    
              quantity    
          }    
      }    
      condVentas{    
          id,    
          price,    
          currency,    
          isCatalogo    
      }    
      variants    
      href    
      thumbnail    
      siteId    
      sellerId    
      status       
      seller {       
          ...articleSellerFields    
      }    
      sellerData {
        nickname
        country_id
        address {
            city
            state
        }
      }
      country {      
          code       
          name    
      }    
      approved {      
          author {        
              id        
              givenName        
              familyName      
          }      
          createdAt    
      }    
      reported {      
          tags {        
              display        
              active      
          }      
          code       
          description      
          photosDenounced      
          author {        
              id        
              givenName        
              familyName      
          }      
          createdAt      
          isFamily      
          familyId    
      }     
      noticed {      
          sent      
          reason      
          failed       
          sending      
          noticeId      
          noticedAt      
          takeDownAt    
          noticeStatus
      }    
      originModel  
  }
  fragment articlesFields on ArticlesType { 
      articles{
          ...articleFields
      }
   }
query($from: String!, $to: String!, $articleIds: [String]!) {    updateItemsNoticed(from: $from, to: $to, articleIds: $articleIds) {      ...articlesFields    }  }`;